module.exports = __webpack_public_path__ + "static/media/tiny_preview.8ef28df3.png";